import { WordCrossfade } from '@sohanscript/ui/animated/crossfade-text';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/draft/crossfade-text')({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<WordCrossfade
			className="min-w-120 text-6xl lg:text-7xl"
			words={['creative', 'pragmatic', 'curious', 'building']}
		/>
	);
}
